import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=395f7507&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=ts"
export * from "./AuthPage.vue?vue&type=script&lang=ts"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=395f7507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f7507",
  null
  
)

export default component.exports